/** @format */
import React from 'react';
import styled from 'styled-components';
// import ComeFunzionaSottoHomePage from 'components/shared/ComeFunzionaSottoHomePage';
import media from 'utils/media-queries';
import ComeFunzionaCarousel from 'components/shared/ComeFunzionaCarousel';
// import { stepList } from '../constants/steplist';
import { Column } from 'components/ui/Grid';
import Text from 'components/ui/Text';
import comeFunzionaImg018 from 'images2/comefunziona-img-0-18/img-come-funziona-0-18.png';
import { HOME_ANCHORS } from '../constants/anchors';

const Wrapper = styled.div`
  ${media.xs`
    padding-bottom: 5.5rem;
  `}
  ${media.xsm`
    padding-bottom: 5rem;
  `}
  ${media.md`
    padding-bottom: 9.6rem;
  `}
  height: auto;
`;

const HowItWorks = () => (
  <Wrapper id={HOME_ANCHORS.comeFunziona}>
    {/* <ComeFunzionaSottoHomePage
      color="blue"
      stepList={stepList}
      text="Puoi cercare, personalizzare e acquistare attività per bambine e bambini, ragazzi e ragazze, gratuite o a pagamento, disponibili in città ed erogate dalla rete di"
    /> */}
    <ComeFunzionaCarousel color="blue">
      <>
        <Column padding="0 0 0.5rem 0">
          <Text
            value="Il"
            color="black"
            size="f7"
          />
          &nbsp;
          <Text
            value="progetto WISH MI"
            color="black"
            size="f7"
            weight="bold"
          />
          &nbsp;
          <Text
            value="(01 /09 / 2019 - 31 /08 / 2023), coordinato dal Comune di Milano, aveva l'obiettivo di affrontare alcune delle sfide prioritarie in materia di povertà infantile e promuovere il benessere di tutt */e le bambine, i bambini, le ragazze e i ragazzi (0-18) presenti sul territorio milanese."
            color="black"
            size="f7"
          />
        </Column>
        <Column padding="0 0 0.5rem 0">
          <Text
            value="Grazie a WISH MI, è stato creato su questa piattaforma il"
            color="black"
            size="f7"
          />
          &nbsp;
          <Text
            value="Catalogo Milano 0 - 18"
            color="black"
            size="f7"
            weight="bold"
          />
          <Text
            value=", in cui sono stati inseriti vari servizi offerti da enti profit e no profit, selezionati tramite un avviso pubblico.Al termine del progetto erano 95 gli enti aderenti al Catalogo, che offrivano, in totale, più di 750 servizi."
            color="black"
            size="f7"
          />
        </Column>
        <Column padding="0 0 0.5rem 0">
          <Text
            value="È stato realizzato un sistema di"
            color="black"
            size="f7"
          />
          &nbsp;
          <Text
            value="voucher digitali"
            color="black"
            size="f7"
            weight="bold"
          />
          <Text
            value=", che le famiglie potevano utilizzare per accedere ai servizi.L'Avviso per l'assegnazione dei voucher digitali ha visto una grande partecipazione delle famiglie: le domande pervenute sono state 25.799"
            color="black"
            size="f7"
          />
        </Column>
        <Column padding="0 0 0.5rem 0">
          <Text
            value="È stata stilata una graduatoria nell'ottobre 2022 sulla base di criteri inerenti alla composizione del nucleo familiare e alla presenza di componenti con disabilità.Alle famiglie collocate in posizione utile è stato erogato un voucher associato al minore per cui era stata presentata la richiesta, da spendere interamente o parzialmente entro il 31 luglio 2023, a copertura totale o parziale del costo del servizio prescelto.L'importo del voucher, compreso tra 100 € e 400 €, è stato definito sulla base dell'ISEE familiare."
            color="black"
            size="f7"
          />
        </Column>
        <Column padding="0 0 0.5rem 0">
          <Text
            value="Lo stanziamento previsto ha permesso di accogliere circa una domanda su quattro: sono stati infatti assegnati 5.544 voucher ad altrettanti minori, per un totale di"
            color="black"
            size="f7"
          />
          &nbsp;
          <Text
            value="2.099.752 €"
            color="black"
            size="f7"
            weight="bold"
          />
          <Text
            value=". Sono complessivamente 2.491 le famiglie che hanno beneficiato del voucher."
            color="black"
            size="f7"
          />
        </Column>
        <Column padding="0 0 4rem 0">
          <Text
            value="Attualmente, il catalogo non è attivo.L'Amministrazione sta infatti ricercando nuovi fondi attraverso i quali migliorare e riattivare questo utile strumento."
            color="black"
            size="f7"
          />
        </Column>
        <img
          src={comeFunzionaImg018}
          alt=""
          height="auto"
          width="auto"
        />
      </>
    </ComeFunzionaCarousel>
  </Wrapper>
);

HowItWorks.displayName = 'HowItWorks';

export default React.memo(HowItWorks);
